import { Trans } from '@lingui/react'
import { Container, Grid, makeStyles, Paper, useTheme } from '@material-ui/core'
import Typography from '@material-ui/core/Typography/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React, { FunctionComponent } from 'react'

const getStyles = (isScreenXS: boolean) => {
  return makeStyles(theme => ({
    page: {
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      minHeight: '100vh',
      width: '100%',
      paddingTop: '2rem'
    },
    page_full: {
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      minHeight: '100vh',
      width: '100%',
      paddingLeft: '0px',
      paddingRight: '0px'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    img: {
      width: '60%',
      marginTop: isScreenXS ? theme.spacing(1) : theme.spacing(2)
    },
    paper: {
      padding: '1rem'
    },
    grid: {
      textAlign: 'center'
    },
    title: {
      color: '#9BBC4B'
    },
    titleSpacing: {
      marginTop: isScreenXS ? theme.spacing(2) : '',
      marginBottom: isScreenXS ? theme.spacing(2) : ''
    },
    InfoOutlinedIcon: {
      fontSize: 75,
      color: 'red'
    }
  }))
}

export interface BrowserNotSupportedProps {
  nameBrowser: string
}

const BrowserNotSupported: FunctionComponent<BrowserNotSupportedProps> = ({ nameBrowser }) => {
  const theme = useTheme()
  const isScreenXS = useMediaQuery(theme.breakpoints.down('xs'))
  const useStyles = getStyles(isScreenXS)
  const classes = useStyles()

  return (
    <div className={isScreenXS ? classes.page_full : classes.page} data-testid='browserNotSupported'>
      <Container maxWidth='md' disableGutters={isScreenXS}>
        <Paper elevation={3} className={classes.paper}>
          <Grid container={true} justify='center' spacing={2}>
            <Grid item={true} xs={isScreenXS ? 12 : 6} className={classes.grid}>
              <img
                className={classes.img}
                src='https://imedicalmarketing.blob.core.windows.net/portal-imedical/logos/imedicalcloud-logo-color.png?sv=2025-07-05&spr=https&st=2026-05-28T16%3A21%3A12Z&se=2027-01-01T16%3A27%3A00Z&sr=b&sp=r&sig=%2FxP%2BfxJjGxKwe6jfGExq2HncyaU2v6LxeYOQvtk6KX8%3D'
                alt='iMedicalCloud'
              />
            </Grid>
            <Grid item={true} xs={isScreenXS ? 12 : 6} className={classes.grid}>
              <h2 id='telemedicinaHeader' className={classes.titleSpacing}>
                <Trans id='' message={'Bienvenido al portal de Teleconsulta'} />
              </h2>
            </Grid>
          </Grid>
          <Grid container={true} justify='center' spacing={2}>
            <Grid className={classes.grid}>
              <Typography className={classes.grid}>
                <InfoOutlinedIcon className={classes.InfoOutlinedIcon} />
              </Typography>
              <div className={classes.paper}>
                <Typography component='h1'>
                  <Trans id='' message={`Navegador ${nameBrowser} no soportado. Por favor use Google Chrome`} />
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </div>
  )
}

export default BrowserNotSupported
